// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPlayCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PPlayCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PPlayCircleOutlined = function PPlayCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPlayCircleOutlinedSvg
  }));
};

PPlayCircleOutlined.displayName = 'PPlayCircleOutlined';
export default React.forwardRef(PPlayCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPlayCircleOutlined.js
// module id = 3542
// module chunks = 0